import { Component } from 'react';

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', error, info.componentStack);
  }

  render() {
    if (this.state.error) {
      if (this.props.fallback) return this.props.fallback(this.state.error, () => this.setState({ error: null }));

      return (
        <div style={{
          minHeight: this.props.inline ? 'auto' : '100vh',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          background: 'var(--bg)', color: 'var(--tx)', padding: 24,
        }}>
          <div style={{ maxWidth: 400, textAlign: 'center' }}>
            <div style={{ fontSize: 40, marginBottom: 12 }}>⚠️</div>
            <h2 style={{ fontSize: 18, fontWeight: 700, marginBottom: 8 }}>Algo deu errado</h2>
            <p style={{ fontSize: 13, color: 'var(--t3)', marginBottom: 20 }}>
              {this.props.message || 'Ocorreu um erro inesperado. Recarregue a página.'}
            </p>
            <button
              onClick={() => this.setState({ error: null })}
              style={{ padding: '9px 24px', borderRadius: 9, border: 'none', background: 'var(--br)', color: '#fff', fontWeight: 600, cursor: 'pointer', marginRight: 8 }}
            >
              Tentar novamente
            </button>
            <button
              onClick={() => window.location.reload()}
              style={{ padding: '9px 24px', borderRadius: 9, border: '1px solid var(--bd)', background: 'transparent', color: 'var(--tx)', fontWeight: 600, cursor: 'pointer' }}
            >
              Recarregar
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

/** Lightweight wrapper para erros dentro de modais/cards. */
export function ModalErrorBoundary({ children }) {
  return (
    <ErrorBoundary
      inline
      message="Não foi possível carregar este componente."
      fallback={(err, retry) => (
        <div style={{ padding: 20, textAlign: 'center' }}>
          <p style={{ fontSize: 13, color: 'var(--rd)', marginBottom: 10 }}>Erro: {err.message}</p>
          <button onClick={retry} style={{ padding: '7px 18px', borderRadius: 8, border: 'none', background: 'var(--br)', color: '#fff', cursor: 'pointer', fontSize: 12 }}>
            Tentar novamente
          </button>
        </div>
      )}
    >
      {children}
    </ErrorBoundary>
  );
}
